import Typography from '@mui/material/Typography';

const PageHeader = ({ children, sx, dataAutomationId, ...props }) => (
    <Typography
        variant="h1"
        sx={{
            fontWeight: 700,
            fontSize: '2.0rem',
            lineHeight: '2.75rem',
            pb: '5px',
            m: 0,
            textAlign: 'center',
            ...sx,
        }}
        {...(dataAutomationId ? { 'data-automation-id': dataAutomationId } : {})}
        {...props}
    >
        {children}
    </Typography>
);

export default PageHeader;
